import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cryptoAddress',

})
export class CryptoAddressPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    return value.replace('bitcoincash:', '');
  }

}
